import { NgModule } from '@angular/core';
import { EntityDataModule, HttpUrlGenerator } from '@ngrx/data';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PluralHttpUrlGenerator } from './plural-http-generator.provider';
import { AppEntityService } from './providers/entity.service';
import { AlertStoreModule, AuthStoreModule, RouterStoreModule, StatusGraphStoreModule } from './stores';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

const stores = [AlertStoreModule, RouterStoreModule, AuthStoreModule, StatusGraphStoreModule];

@NgModule({
  imports: [
    StoreModule.forRoot({}),
    EffectsModule.forRoot(),
    EntityDataModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: false,
      autoPause: true,
      features: {
        pause: false,
        lock: true,
        persist: true,
      },
    }),
    ...stores,
  ],
  providers: [AppEntityService, { provide: HttpUrlGenerator, useClass: PluralHttpUrlGenerator }],
})
export class AppStoreModule {}
